import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../../contexts/AuthContext";
import { configService } from "../../../../services/configService";
import { permitteesService } from "../../../../services/permitteesService";
import { getPrintTemplate } from "./printTemplateFactory";
import { processesService } from "../../../../services/processesService";
import LetterPrint from "../../Processes/LetterPrint";
import ReactDOMServer from "react-dom/server";
import { generateQrCodeBase64, generateQrCodeSne } from "./utils";
import { PrintFinalDecision } from "../../Processes/PrintFinalDecision";
import { ROUTES } from "../../../../constants/routes-path";

export default function DocumentPrintBatchPage() {
    const { codes = "", userId, code = "" } = useParams();
    const codeList = codes ? codes.split(",") : [];
    const [html, setHtml] = useState("");
    const { getUserData } = useContext(AuthContext);
    const user = getUserData();

    useEffect(() => {
        const load = printHtmlBase(codeList, code, user, setHtml);

        load();
    }, [codes, userId]);

    return <div dangerouslySetInnerHTML={{ __html: html }} />;
}

export function printHtmlBase(codeList, code, user, setHtml) {
    return async () => {
        try {
            const config = await configService.get();
            const documents = await permitteesService.fetchDocumentsByCodeList(codeList.length ? codeList : [code]);

            const htmlPages = await Promise.all(
                documents.map(async (data, index, array) => {
                    const generator = getPrintTemplate(data.tipo);
                    const breakNewPage = index < array.length - 1;
                    return await generator(config, data, user, breakNewPage);
                })
            );

            const htmlComplete = htmlPages.join('');

            setHtml(`<!DOCTYPE html>
                    <html lang="pt-BR">
                      <head>
                        <meta charset="UTF-8">
                        <title>GOTT - Gestor de Operações de Trânsito e Transporte</title>
                        <link
                          rel="stylesheet"
                          href="https://cdn.jsdelivr.net/npm/bootstrap@3.3.7/dist/css/bootstrap.min.css"
                        />
                        <style>
                            @media print {
                               @page {
                                 margin: 0;
                                 size: auto;
                               }
                               body {
                                 margin: 0;
                               }
                               header, footer {
                                  display: none;
                               }
                            }
                            img, svg{
                              display: inline-block
                            }
                        </style>
                      </head>
                      <body>
                        ${htmlComplete}
                      </body>
                    </html>`);
        } catch (error) {
            console.error("Erro ao gerar impressão", error);
            setHtml(
                `<div class="alert alert-danger">Erro ao gerar impressão: ${error.message}</div>`
            );
        }
    };
}

export function PrintProcessLetter() {
    const { id = "" } = useParams();
    const [html, setHtml] = useState("");

    useEffect(() => {
        const load = async () => {
            try {
                const processDetail = await processesService.find(id);
                const config = await configService.get();
                const qrCode = await generateQrCodeSne();

                const content = ReactDOMServer.renderToStaticMarkup(
                    <LetterPrint process={processDetail} config={config} qrCode={qrCode} />
                );

                const fullHtml = `
                  <!DOCTYPE html>
                  <html lang="pt-BR">
                    <head>
                      <meta charset="UTF-8">
                      <title>GOTT - Gestor de Operações de Trânsito e Transporte</title>
                      <link
                        rel="stylesheet"
                        href="https://cdn.jsdelivr.net/npm/bootstrap@3.3.7/dist/css/bootstrap.min.css"
                      />
                      <link
                        rel="stylesheet"
                        href="/assets/table-sgmt.css"
                      />
                      <style>
                        @media print {
                          @page {
                            size: auto;
                          }
                          header, footer {
                            display: none;
                          }
                        }
                      </style>
                    </head>
                    <body>
                      ${content}
                      <script>
                        window.onload = function() {
                          window.print();
                        }
                      </script>
                    </body>
                  </html>`;

                setHtml(fullHtml);
            } catch (error) {
                console.error("Erro ao gerar impressão", error);
                setHtml(
                    `<div class="alert alert-danger">Erro ao gerar impressão: ${error.message}</div>`
                );
            }
        };

        load();
    }, [id]);

    return <div dangerouslySetInnerHTML={{ __html: html }} />;
}

export function PrintProcessFinalDecision() {
    const { id = "" } = useParams();
    const [html, setHtml] = useState("");

    useEffect(() => {
        const load = async () => {
            try {
                const processDetail = await processesService.find(id);
                const config = await configService.get();
                const qrCode = await generateQrCodeBase64(`${window.location.origin}${ROUTES.processPrintFinalDecision.replace(":id", id)}`, { width: 128, errorCorrectionLevel: 'L' });

                const content = ReactDOMServer.renderToStaticMarkup(
                    <PrintFinalDecision process={processDetail} config={config} qrCode={qrCode} />
                );

                const fullHtml = `
                  <!DOCTYPE html>
                  <html lang="pt-BR">
                    <head>
                      <meta charset="UTF-8">
                      <title>GOTT - Gestor de Operações de Trânsito e Transporte</title>
                      <link
                        rel="stylesheet"
                        href="https://cdn.jsdelivr.net/npm/bootstrap@3.3.7/dist/css/bootstrap.min.css"
                      />
                      <style>
                        @media print {
                          @page {
                            size: auto;
                          }
                          header, footer {
                            display: none;
                          }
                        }
                      </style>
                    </head>
                    <body>
                      ${content}
                      <script>
                        window.onload = function() {
                          window.print();
                        }
                      </script>
                    </body>
                  </html>`;

                setHtml(fullHtml);
            } catch (error) {
                console.error("Erro ao gerar impressão", error);
                setHtml(
                    `<div class="alert alert-danger">Erro ao gerar impressão: ${error.message}</div>`
                );
            }
        };

        load();
    }, [id]);

    return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
